module.exports = __webpack_public_path__ + "media/scholarships/fastweb-x-calendar-879eb3d0.svg";